module.exports = __webpack_public_path__ + "static/media/main_course.7464d50c.svg";